import {i18n} from '@netx/core-next/locales';
import {parseHtmlEntities} from '@netx/core-next/utils/string';
import type {CustomFormLocale} from '../types';

export const getCustomFormItemTranslatedLabel = (
	itemLocale?: CustomFormLocale,
) => {
	if (!itemLocale) return '';

	const localeKeys = Object.keys(itemLocale).map((locale) =>
		locale.toLowerCase(),
	);
	const localeValues = Object.values(itemLocale);

	const language = (i18n.language || 'en-US').toLowerCase();
	const languageWithoutRegion = language.split('-')[0];

	const index =
		localeKeys.indexOf(language) !== -1
			? localeKeys.indexOf(language)
			: localeKeys.indexOf(languageWithoutRegion);
	if (localeValues[index] != null)
		return parseHtmlEntities(localeValues[index]);

	const firstLocaleIndex = localeKeys.findIndex((key) => key !== 'key');
	if (localeValues[firstLocaleIndex])
		return parseHtmlEntities(localeValues[firstLocaleIndex]);

	return parseHtmlEntities(
		localeValues[localeKeys.indexOf('key')] || itemLocale.en || '',
	);
};

export default getCustomFormItemTranslatedLabel;
